export { projectInfo };
import { PROJECT_VERSION } from './PROJECT_VERSION';
const projectInfo = {
    projectName: 'react-streaming',
    projectVersion: PROJECT_VERSION,
    npmPackageName: 'react-streaming',
    githubRepository: 'https://github.com/brillout/react-streaming',
};
